module.exports = __webpack_public_path__ + "static/media/seguradora_bradesco.7b54cade.png";